import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { DomSanitizer, SafeResourceUrl, Title } from '@angular/platform-browser';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';

const GRAFANA_URL =
  'https://goul.org/grafana/d/ai-requests-log/ai-requests-log?orgId=1&from=now-24h&to=now&timezone=browser&theme=light&kiosk';

@Component({
  selector: 'app-ai-requests-log-report',
  standalone: true,
  imports: [CommonModule, ButtonModule, CardModule],
  templateUrl: './ai-requests-log-report.component.html',
  styleUrls: ['./ai-requests-log-report.component.css'],
})
export class AiRequestsLogReportComponent {
  readonly grafanaUrl: SafeResourceUrl;

  constructor(private router: Router, sanitizer: DomSanitizer, titleService: Title) {
    this.grafanaUrl = sanitizer.bypassSecurityTrustResourceUrl(GRAFANA_URL);
    titleService.setTitle('NotesApp - AI Requests Log');
  }

  close(): void {
    this.router.navigate(['/home']);
  }
}
